import React, { useState } from 'react';

const TableOfContent = () => {
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className="container-1 benefits page-padding">
                <div className="col-12 text-center mb-5">
                    <h2 className="panel-name">Table of Contents</h2>
                </div>
                <div className="row  d-flex justify-content-center">
                    <div className="col-12 col-sm-12 col-lg-10 ">
                        <div className="row table-contents-wrapper">
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    01
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('report-overview')}>
                                    Report - Overview
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    02
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('report-summary')}>
                                    Summary of "Out of range" parameters
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    03
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('critical-parameters')}>
                                    Details of "Out of range" parameters
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    04
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('report-details')}>
                                    Detailed report
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    05
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('diet-recomendation')}>
                                    Diet recommendations
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    06
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('lifestyle-recomendation')}>
                                    Lifestyle recommendations
                                </div>
                            </div>
                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    07
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('test-recomendation')}>
                                    Test recommendations
                                </div>
                            </div>

                            <div className="col-12 mb-5 d-flex align-items-center">
                                <div className="count">
                                    08
                                </div>
                                <div className="table-contents d-flex" onClick={() => scrollToSection('references')}>
                                    References
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TableOfContent;